import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"

const IconLinkedin = ({
  title = "Linkedin",
  viewBoxWidth = 32,
  viewBoxHeight = 32,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <path
      d="M16 32a16 16 0 110-32 16 16 0 010 32zm8-10v-5.8c0-3.1-1.7-4.6-4-4.6-1.8 0-2.6 1-3 1.7V12h-3.5V22H17v-5.7-.8c.3-.6.9-1.2 1.8-1.2 1.3 0 1.8 1 1.8 2.3V22H24zM10 10.5c1.1 0 1.9-.8 1.9-1.8S11 7 9.9 7C8.8 7 8 7.8 8 8.7c0 1 .7 1.8 1.9 1.8zM11.5 22V11.9H8.2V22h3.4z"
      fill="#0077B5"
      fillRule="evenodd"
    />
  </Svg.Icon>
)

export default IconLinkedin
